import React from 'react';
import { X, RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

export const UpdateNotification: React.FC = () => {
  const { updateAvailable, dismiss } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        width: 320,
        zIndex: 999998,
        display: 'flex',
        overflow: 'hidden',
        borderRadius: 12,
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.12)',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      {/* Green accent bar */}
      <div style={{ width: 4, flexShrink: 0, backgroundColor: '#2bb673' }} />

      <div style={{ flex: 1, padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: '#1a1a1a', lineHeight: '20px' }}>
            A new version of Prophitable is available
          </span>
          <button
            onClick={dismiss}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 2,
              marginLeft: 8,
              flexShrink: 0,
              color: '#6b7280',
              display: 'flex',
              alignItems: 'center',
            }}
            aria-label="Dismiss update notification"
          >
            <X size={16} />
          </button>
        </div>

        <button
          onClick={() => window.location.reload()}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '8px 16px',
            fontSize: 13,
            fontWeight: 600,
            color: '#ffffff',
            backgroundColor: '#2bb673',
            border: 'none',
            borderRadius: 8,
            cursor: 'pointer',
            width: '100%',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#239861'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#2bb673'; }}
        >
          <RefreshCw size={14} />
          Update now
        </button>
      </div>
    </div>
  );
};
